import script from "./ArchiveReader.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchiveReader.vue?vue&type=script&setup=true&lang=js"

import "./ArchiveReader.vue?vue&type=style&index=0&id=4349bfe6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4349bfe6"]])

export default __exports__